import {useEnvironment} from '@wix/yoshi-flow-editor'
import React from 'react'
import {DETAILS_ROUTE} from '../../../../../../commons/constants/navigation'
import {DesktopCheckout} from '../../checkout/desktop-checkout'
import {MobileCheckout} from '../../checkout/mobile-checkout'
import {RsvpForm} from '../../rsvp-form'
import {FormEntryProps} from './interfaces'

const FormEntry = ({route, ticketed}: FormEntryProps) => {
  const {isMobile, isEditor} = useEnvironment()

  const getCheckoutComponent = () => {
    if (isEditor && !ticketed) {
      return null
    }

    return isMobile ? <MobileCheckout /> : <DesktopCheckout />
  }

  switch (route) {
    case DETAILS_ROUTE.TICKET_FORM:
      return getCheckoutComponent()
    case DETAILS_ROUTE.FORM:
      return <RsvpForm />
    case DETAILS_ROUTE.CHECKOUT:
      return <MobileCheckout />
  }

  return null
}

export default FormEntry
